import 'svelte/internal/disclose-version';

Chat[$.FILENAME] = 'src/web/concepts/chat.svelte';

import * as $ from 'svelte/internal/client';
import { tick } from "svelte";
import SlotPicker from "./slot_picker.svelte";

var root = $.add_locations(
	$.from_html(
		`
      <p> </p>
    `,
		1
	),
	Chat[$.FILENAME],
	[[54, 6]]
);

var root_1 = $.add_locations($.from_html(`<p class="self-start px-4 py-3 bg-ink text-accent animate-pulse">…</p>`), Chat[$.FILENAME], [[56, 16]]);

var root_2 = $.add_locations(
	$.from_html(
		`
      <!>
    `,
		1
	),
	Chat[$.FILENAME],
	[]
);

var root_3 = $.add_locations(
	$.from_html(
		`
      <form class="flex gap-3">
        <input class="field flex-1"/>
        <button class="btn">Send</button>
      </form>
    `,
		1
	),
	Chat[$.FILENAME],
	[[62, 6, [[63, 8], [64, 8]]]]
);

var root_4 = $.add_locations(
	$.from_html(
		`
    <!>
  `,
		1
	),
	Chat[$.FILENAME],
	[]
);

var root_5 = $.add_locations(
	$.from_html(
		`

<div class="w-full max-w-2xl flex flex-col gap-4">
  <div class="flex flex-col gap-3 max-h-[55dvh] overflow-y-auto pr-2">
    <!>
    <!>
  </div>
  <!>
</div>`,
		1
	),
	Chat[$.FILENAME],
	[[51, 0, [[52, 2]]]]
);

function Chat($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Chat);

	const script = [
		"Hi. What does your company do?",
		"And what eats most of your team's time right now?",
		"Got it. That's exactly the kind of thing we build for. Let's talk it through on a 30-minute video call. When works?",
		"Last thing: where do we send the link?"
	];

	let messages = $.tag_proxy($.proxy([]), 'messages');
	let step = $.tag($.state(0), 'step');
	let typing = $.tag($.state(false), 'typing');
	let input = $.tag($.state(""), 'input');
	let slot = $.tag($.state(null), 'slot');
	let done = $.tag($.state(false), 'done');
	let thread;

	const say = async (text) => {
		$.set(typing, true);
		(await $.track_reactivity_loss(new Promise((r) => setTimeout(r, 700))))();
		$.set(typing, false);
		messages.push({ from: "us", text });
		(await $.track_reactivity_loss(tick()))();
		thread?.scrollTo({ top: thread.scrollHeight, behavior: "smooth" });
	};

	const send = async (text) => {
		if (!text.trim()) return;

		messages.push({ from: "you", text });
		$.set(input, "");
		$.update(step);

		if ($.strict_equals($.get(step), 4)) {
			$.set(done, true);
			(await $.track_reactivity_loss(say(`Booked for ${$.get(slot)}. The link is on its way to ${text}. Talk soon.`)))();

			return;
		}

		(await $.track_reactivity_loss(say(script[$.get(step)])))();
	};

	$.user_effect(() => {
		if ($.get(slot) && $.strict_equals($.get(step), 2)) send($.get(slot));
	});

	say(script[0]);

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_5();
	var div = $.sibling($.first_child(fragment));
	var div_1 = $.sibling($.child(div));
	var node = $.sibling($.child(div_1));

	$.add_svelte_meta(
		() => $.each(node, 17, () => messages, $.index, ($$anchor, m) => {
			$.next();

			var fragment_1 = root();
			var p = $.sibling($.first_child(fragment_1));
			var text_1 = $.only_child(p, true);

			$.next();

			$.template_effect(() => {
				$.set_class(p, 1, $.clsx([
					"max-w-[85%] px-4 py-3 text-lg",
					$.strict_equals($.get(m).from, "us")
						? "self-start bg-ink text-accent"
						: "self-end border-2 border-ink"
				]));

				$.set_text(text_1, $.get(m).text);
			});

			$.append($$anchor, fragment_1);
		}),
		'each',
		Chat,
		53,
		4
	);

	var node_1 = $.sibling(node, 2);

	{
		var consequent = ($$anchor) => {
			var p_1 = root_1();

			$.append($$anchor, p_1);
		};

		$.add_svelte_meta(
			() => $.if(node_1, ($$render) => {
				if ($.get(typing)) $$render(consequent);
			}),
			'if',
			Chat,
			56,
			4
		);
	}

	$.next();
	$.reset(div_1);
	$.bind_this(div_1, ($$value) => thread = $$value, () => thread);

	var node_2 = $.sibling(div_1, 2);

	{
		var consequent_2 = ($$anchor) => {
			var fragment_2 = root_4();
			var node_3 = $.sibling($.first_child(fragment_2));

			{
				var consequent_1 = ($$anchor) => {
					var fragment_3 = root_2();
					var node_4 = $.sibling($.first_child(fragment_3));

					$.add_svelte_meta(
						() => SlotPicker(node_4, {
							get value() {
								return $.get(slot);
							},

							set value($$value) {
								$.set(slot, $$value, true);
							}
						}),
						'component',
						Chat,
						60,
						6,
						{ componentTag: 'SlotPicker' }
					);

					$.next();
					$.append($$anchor, fragment_3);
				};

				var alternate = ($$anchor) => {
					var fragment_4 = root_3();
					var form = $.sibling($.first_child(fragment_4));
					var input_1 = $.sibling($.child(form));

					$.remove_input_defaults(input_1);
					$.autofocus(input_1, true);
					$.next(3);
					$.reset(form);
					$.next();

					$.template_effect(() => {
						$.set_attribute(input_1, 'type', $.strict_equals($.get(step), 3) ? "email" : "text");
						$.set_attribute(input_1, 'placeholder', $.strict_equals($.get(step), 3) ? "you@company.com" : "Type your answer");
					});

					$.event('submit', form, function submit(e) {
						e.preventDefault();
						send($.get(input));
					});

					$.bind_value(
						input_1,
						function get() {
							return $.get(input);
						},
						function set($$value) {
							$.set(input, $$value);
						}
					);

					$.append($$anchor, fragment_4);
				};

				$.add_svelte_meta(
					() => $.if(node_3, ($$render) => {
						if ($.strict_equals($.get(step), 2)) $$render(consequent_1); else $$render(alternate, -1);
					}),
					'if',
					Chat,
					59,
					4
				);
			}

			$.next();
			$.append($$anchor, fragment_2);
		};

		$.add_svelte_meta(
			() => $.if(node_2, ($$render) => {
				if (!$.get(done) && !$.get(typing) && messages.length) $$render(consequent_2);
			}),
			'if',
			Chat,
			58,
			2
		);
	}

	$.next();
	$.reset(div);
	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	Chat = $.hmr(Chat);

	import.meta.hot.accept((module) => {
		Chat[$.HMR].update(module.default);
	});
}

export default Chat;